import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import FilterRow from "../components/FilterRow/FilterRow";
import Modal from "../components/Modal/Modal";
import OfferForm from "../components/OfferForm/OfferForm";
import OfferPreviewRow from "../components/OfferPreviewRow/OfferPreviewRow";
import OfferRow from "../components/OfferRow/OfferRow";
import PaginationWrapper from "../components/PaginationWrapper/PaginationWrapper";
import { usePageContext } from "../context/PageContext";
import Button from "../ui/Button/Button";
import Input, { DateInput, Textarea } from "../ui/Input/Input";
import Table from "../ui/Table/Table";

const MainPage = observer(() => {
    const { pageStore } = usePageContext();

    const {
        user,
        limitArray,
        offersLimit: limit,
        offersPage: page,
        offersPages: pages,
        setOffersLimit: setLimit,
        setOffersPage: setPage
    } = pageStore;

    const samplePrompt = '🇹🇷TR\nFunnels: Baykar, KOC\nSource: GG+FB\nCRG: 900+5\nCR 5-6%\n\n🇮🇹 IT\nFunnel: Medici Capitale\nSource: GG\nCRG = 1150+8\nCR 14+%\n\nFR\nFunnel: Trader_AI\nCR: 7%\nCPL: 90$';
    const [maxDate, setMaxDate] = useState('');
    const [isCopied, setIsCopied] = useState(false);

    const [createModal, setCreateModal] = useState(false);
    const [updateOffer, setUpdateOffer] = useState(null);
    const [deleteModal, setDeleteModal] = useState(false);

    const [prompt, setPrompt] = useState('');
    const [initialPrompt, setInitialPrompt] = useState('');
    const [rawJson, setRawJson] = useState('');
    const [thread, setThread] = useState('');
    const [team, setTeam] = useState('');
    const [teamError, setTeamError] = useState('');
    const [tempOffers, setTempOffers] = useState([]);
    const [openFeedback, setOpenFeedback] = useState(false)
    const [allOffersSelected, setAllOffersSelected] = useState(false);

    // Local search
    const [filterValues, setFilterValues] = useState({
        display_line: '',
        team: '',
        cc: '',
        language: '',
        model: '',
        price: '',
        cr: '',
        funnels: '',
        sources: '',
        createdAt: '',
    });
    // Search
    const [search, setSearch] = useState({});
    const [searchDraft, setSearchDraft] = useState({});

    const getFilteredList = (list) => {
        return list.filter(item => {
            return Object.entries(filterValues).every(([key, value]) => {
                if (!value.trim()) return true;
                const itemValue = item[key] ? String(item[key]).toLowerCase() : "";
                return itemValue.includes(String(value).toLowerCase());
            });
        });
    };

    const handleSelectUpdate = async () => {
        const selectedOffer = pageStore.offers.find(offer => offer.selected);
        if (selectedOffer) setUpdateOffer(selectedOffer);
    };

    const handleCopyMany = async () => {
        if (typeof navigator !== 'undefined' && navigator.clipboard) {
            try {
                const copiedName = pageStore.offers
                    .filter(offer => offer.selected)
                    .map(offer => offer.display_line)
                    .join('\n');
                await navigator.clipboard.writeText(copiedName);
                if (!isCopied) {
                    setIsCopied(true);
                    setTimeout(() => {
                        setIsCopied(false);
                    }, 1000)
                }
            } catch (err) {
                console.error('Error of copy:', err);
            }
        }
    };

    const handleSendPrompt = async () => {
        if (prompt.trim().replace(/\s|\n/g, '').length > 0) {
            if (!thread) setInitialPrompt(prompt);

            const offerData = await pageStore.generateNewOffers(prompt, thread);
            if (offerData?.offers) {
                console.log(offerData);
                setPrompt('');
                setTempOffers(offerData?.offers || []);
                setThread(offerData?.thread || '');
                setOpenFeedback(false);
                setRawJson(JSON.stringify(offerData, null, 2));
            }
        }
    };

    const handleSaveOffers = async () => {
        if (tempOffers.length > 0) {
            if (team.trim() !== '') {
                const newOffers = tempOffers.map(offer => ({ ...offer, team: team.trim() }))
                const { offers = null } = await pageStore.addNewOffers(newOffers, thread);
                if (offers) {
                    setCreateModal(false);
                    setPrompt('');
                    setInitialPrompt('');
                    setTempOffers([]);
                    setThread('');
                    setTeam('');
                    setOpenFeedback(false);
                    await pageStore.getAllOffer();
                }
            } else {
                setTeamError('Team is required');
            }
        }
    };

    const handleUpdateOffer = async (id, offer) => {
        if (id) {
            const { offer: updateOffer = null } = await pageStore.updateOffer(id, offer);
            if (updateOffer) {
                setUpdateOffer(null);
                await pageStore.getAllOffer();
            }
        }

    };

    const handleDeleteOffers = async () => {
        const deleteId = pageStore.offers.filter(offer => offer.selected).map(offer => offer._id)
        if (deleteId.length > 0) {
            const { deletedCount } = await pageStore.deleteOffers(deleteId);
            if (deletedCount) {
                setAllOffersSelected(false);
                setDeleteModal(false);
                await pageStore.getAllOffer();
            }
        }
    };

    const handleChangeFilter = (key, value) => {
        setFilterValues(prev => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleChangeSearch = (key, value) => {
        setSearch(prev => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleApplyFilters = () => {
        const clearSearch = {};
        Object.entries(search).forEach(([key, value]) => {
            const cleanValue = value.trim();
            if (cleanValue) {
                clearSearch[key] = cleanValue;
            }
        });
        setPage(1);
        setSearch(clearSearch);
        setSearchDraft(clearSearch);
    };

    const handleResetFilters = () => {
        setSearch({});
        setSearchDraft(null);
    };

    useEffect(() => {
        const today = new Date().toISOString().split('T')[0];
        setMaxDate(today);
    }, []);

    useEffect(() => {
        console.log('test');
        const params = {
            ...searchDraft
        };
        pageStore.getAllOffer(params);
        setAllOffersSelected(false);
    }, [limit, page, searchDraft]);

    return (
        <>
            <h1>
                Offer Parser → DB
            </h1>

            <div className="tab_container">
                <div className="tab_block">
                    <div className="filter_inputs_wrapper">
                        <div className="search_input_wrapper">
                            <div className="date_filter_wrapper">
                                <Input value={search?.search || ''} onChange={({ target }) => handleChangeSearch('search', target.value)} placeholder={'Search'} className={'search_input'} />
                                <Input value={search?.cc || ''} onChange={({ target }) => handleChangeSearch('cc', target.value)} placeholder={'Geo'} className={'search_input'} />
                            </div>
                            <div className="date_filter_wrapper">
                                <DateInput value={search?.from || ''} onChange={(_, date) => handleChangeSearch('from', date)} maxDate={maxDate} placeholder={'Date from'} />
                                -
                                <DateInput value={search?.to || ''} onChange={(_, date) => handleChangeSearch('to', date)} maxDate={maxDate} minDate={search?.from || ''} placeholder={'Date to'} />
                            </div>
                        </div>
                        <div className="search_btns">
                            <Button disabled={pageStore.isLoading || !Object.values(search).some(val => !!val)} className={'ghost btn_full'} onClick={() => handleResetFilters()}>
                                Clear
                            </Button>
                            <Button disabled={pageStore.isLoading} className={'btn_full'} onClick={() => handleApplyFilters()}>
                                Search
                            </Button>
                        </div>
                    </div>
                    <div className="btns_container">
                        <Button className={'btn_full'} disabled={pageStore.isLoading} onClick={() => setCreateModal(true)}>
                            Add Offer
                        </Button>
                    </div>
                </div>
                <div className={`delete_info_block ${pageStore.offers.filter(offer => offer.selected).length > 0 ? 'visible_block' : ''}`}>
                    <span className="selected_count">
                        {pageStore.offers.filter(offer => offer.selected).length} selected
                    </span>
                    <div className="btns_container">
                        {pageStore.offers.filter(offer => offer.selected).length === 1 &&
                            <Button disabled={pageStore.isLoading} className={'border'} onClick={handleSelectUpdate}>
                                Update selected
                            </Button>
                        }
                        <Button disabled={pageStore.isLoading} className={`accept copy_btn ${isCopied ? 'copy_btn_copied' : ''}`} onClick={handleCopyMany}>
                            Copy selected
                        </Button>
                        {user.role !== 'user' && user.role !== 'stranger' &&
                            <Button disabled={pageStore.isLoading} className={'danger'} onClick={() => setDeleteModal(true)}>
                                Delete selected
                            </Button>
                        }
                    </div>
                </div>

                <Table
                    headings={[
                        '',
                        'Display Name',
                        'Team',
                        'CC',
                        'Lang',
                        'Model',
                        'Price',
                        'CR',
                        'Funnels',
                        'Sources',
                        'Created',
                    ]}
                >
                    <FilterRow
                        filterObj={filterValues}
                        handleChange={handleChangeFilter}
                        selected={allOffersSelected}
                        handleSelectAll={() => {
                            setAllOffersSelected(!allOffersSelected);
                            pageStore.selectAllOffers(!allOffersSelected);
                        }}
                    />
                    {getFilteredList(pageStore.offers).map((offer, i) => (
                        <OfferRow
                            key={i}
                            offer={offer}
                            selected={offer.selected}
                            onToggleSelect={() => pageStore.toggleSelectedOffers(offer._id)}
                        />
                    ))}
                </Table>

                <PaginationWrapper
                    pageCount={pages}
                    forcePage={page}
                    onPageChange={(p) => setPage(p)}
                    limits={limitArray}
                    limit={limit}
                    onChangeLimit={(limitValue) => { setLimit(limitValue); setPage(1); }}
                />
            </div>

            {createModal &&
                <Modal handleClose={() => setCreateModal(false)} className={'modal_full create_offer_modal'}>
                    <div className="create_offer_info_wrapper">
                        <Textarea
                            className={!thread ? 'prompt_area' : ''}
                            readOnly={!!thread}
                            value={!thread ? prompt : initialPrompt}
                            onChange={({ target }) => setPrompt(target.value)}
                            placeholder={'Paste your data here...'}
                        />
                        {!!tempOffers.length &&
                            <>
                                <div className="preview_offers">
                                    <h3>
                                        {`👀 Preview: ${tempOffers.length} entries`}
                                    </h3>
                                    <Table
                                        className={'preview_offers_table'}
                                        headings={[
                                            '#',
                                            'CC',
                                            'Lang',
                                            'Model',
                                            'Price',
                                            'CR',
                                            'Funnels',
                                            'Sources',
                                            'Display',
                                        ]}
                                    >
                                        {tempOffers.map((offer, i) => (
                                            <OfferPreviewRow
                                                key={i}
                                                offer={offer}
                                                i={i + 1}
                                            />
                                        ))}
                                    </Table>
                                </div>
                            </>
                        }
                    </div>

                    {!!tempOffers.length &&
                        <details className="json_text">
                            <summary>
                                Raw assistant JSON (debug)
                            </summary>
                            <pre>
                                {rawJson}
                            </pre>
                        </details>
                    }


                    {thread &&
                        <Input
                            value={team}
                            placeholder={'Team (required to save)'}
                            onChange={({ target }) => { setTeamError(''); setTeam(target.value) }}
                            error={teamError}
                        />
                    }
                    {openFeedback &&
                        <Textarea
                            value={prompt}
                            onChange={({ target }) => setPrompt(target.value)}
                            placeholder={'Give feedback (if required)'}
                        />
                    }
                    <div className="modal_btns">
                        {thread ?
                            <>
                                <Button
                                    disabled={pageStore.isLoading}
                                    className={'ghost'}
                                    onClick={openFeedback ? handleSendPrompt : () => { setOpenFeedback(true) }}
                                >
                                    {openFeedback ? 'Send feedback' : 'Give feedback'}
                                </Button>
                                <Button disabled={pageStore.isLoading} onClick={handleSaveOffers}>
                                    Approve
                                </Button>
                            </>
                            :
                            <>
                                <Button
                                    disabled={pageStore.isLoading || prompt.trim() === ''}
                                    onClick={handleSendPrompt}
                                >
                                    Parse & Preview
                                </Button>
                                <Button disabled={pageStore.isLoading} className={'ghost'} onClick={() => setPrompt(samplePrompt)}>
                                    Load sample
                                </Button>
                            </>
                        }
                    </div>

                </Modal>
            }
            {deleteModal &&
                <Modal handleClose={() => setDeleteModal(false)} className={'modal_center'}>
                    <h1>
                        Delete {pageStore.offers.filter(offer => offer.selected).length} row(s)? This cannot be undone.
                    </h1>

                    <div className="modal_btns">
                        <Button disabled={pageStore.isLoading} onClick={() => setDeleteModal(false)}>
                            Cancel
                        </Button>
                        <Button disabled={pageStore.isLoading} className={'danger'} onClick={handleDeleteOffers}>
                            Delete
                        </Button>
                    </div>
                </Modal>
            }
            {updateOffer &&
                <Modal handleClose={() => setUpdateOffer(null)} className={'modal_form'}>
                    <OfferForm
                        onSubmit={(offer) => handleUpdateOffer(updateOffer?._id, offer)}
                        title={'Update Offer'}
                        disabled={pageStore.isLoading}
                        submitText="Update"
                        offer={updateOffer}
                    />
                </Modal>
            }
        </>
    )
})

export default MainPage